﻿(() => {
  if (window.__CART_CDT__) return;
  window.__CART_CDT__ = 1;

  const formatUnit = (value) => {
    let safeValue = value | 0;

    if (safeValue < 0) safeValue = 0;

    return `${safeValue < 10 ? '0' : ''}${safeValue}`;
  };

  const getStorage = () => {
    try {
      const key = '__cdt__';
      localStorage.setItem(key, '1');
      localStorage.removeItem(key);
      return localStorage;
    } catch {
      return null;
    }
  };

  const resetCountdown = (root) => {
    if (!root) return;

    root.dispatchEvent(new CustomEvent('cdt:destroy'));
    root.removeAttribute('data-initialized');
    root.hidden = false;
    root.style.display = '';

    const line1 = root.querySelector('.cdt-line1');
    const line2 = root.querySelector('.cdt-line2');
    const expired = root.querySelector('.cdt-expired');

    if (line1) line1.hidden = false;
    if (line2) line2.hidden = false;
    if (expired) expired.hidden = true;
  };

  const getLine1 = (root) => root.querySelector('.cdt-line1');

  const getDigitNodes = (root) => {
    const line1 = getLine1(root);

    return {
      line1,
      minutes: line1?.querySelector('.cdt-digit--m .cdt-digit__inner') || null,
      seconds: line1?.querySelector('.cdt-digit--s .cdt-digit__inner') || null,
    };
  };

  const syncLine2Visibility = (root) => {
    const line2 = root.querySelector('.cdt-line2');
    const showLine2 = String(root.dataset.showLine2 || 'true') === 'true';
    const hasLine2 = showLine2 && !!line2 && line2.innerHTML.trim() !== '';

    if (line2) {
      line2.hidden = !hasLine2;
    }

    return hasLine2;
  };

  const initCountdown = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    const initialNodes = getDigitNodes(root);
    const line1 = initialNodes.line1;
    const minutes = initialNodes.minutes;
    const seconds = initialNodes.seconds;

    if (!minutes || !seconds) return;
    root.dataset.initialized = 'true';

    const storage = getStorage();
    const storageKey = root.dataset.lsKey || 'cdt-default';
    const endKey = `${storageKey}:end`;
    const frozenKey = `${storageKey}:frozen`;
    const expiredKey = `${storageKey}:expired`;

    if (root.dataset.cartEmpty === 'true') {
      if (storage) {
        storage.removeItem(endKey);
        storage.removeItem(frozenKey);
        storage.removeItem(expiredKey);
      }
      root.hidden = true;
      return;
    }

    const behavior = root.dataset.behavior || 'restart';
    const duration = Math.max(0, parseInt(root.dataset.duration || '0', 10));
    const expired = root.querySelector('.cdt-expired');
    const expiredText = root.dataset.expiredText || '';
    const hasLine2 = syncLine2Visibility(root);

    if (storage) {
      if (behavior !== 'freeze_zero') storage.removeItem(frozenKey);

      const savedExpiredState = storage.getItem(expiredKey);
      if (savedExpiredState && savedExpiredState !== behavior) {
        storage.removeItem(expiredKey);
      }
    }

    const showZero = () => {
      const currentLine1 = getLine1(root);
      const currentLine2 = root.querySelector('.cdt-line2');
      const currentDigits = getDigitNodes(root);

      if (currentLine1) currentLine1.hidden = false;
      if (currentLine2) currentLine2.hidden = !hasLine2;
      if (expired) expired.hidden = true;

      if (currentDigits.minutes && currentDigits.minutes.textContent !== '00') {
        currentDigits.minutes.textContent = '00';
      }

      if (currentDigits.seconds && currentDigits.seconds.textContent !== '00') {
        currentDigits.seconds.textContent = '00';
      }
    };

    const applyExpiredBehavior = (mode) => {
      const currentLine1 = getLine1(root);
      const currentLine2 = root.querySelector('.cdt-line2');

      switch (mode) {
        case 'hide_block':
          root.style.display = 'none';
          break;
        case 'replace_text':
          if (currentLine1) currentLine1.hidden = true;
          if (currentLine2) currentLine2.hidden = true;
          if (expired) {
            expired.hidden = false;
            expired.textContent = expiredText || (window.hyperflowStrings?.cartCountdownExpired || "Your cart reservation has expired.");
          }
          break;
        case 'freeze_zero':
          showZero();
          break;
      }
    };

    if (storage) {
      if (behavior === 'freeze_zero' && storage.getItem(frozenKey) === '1') {
        showZero();
        return;
      }

      const savedExpiredState = storage.getItem(expiredKey);
      if (
        savedExpiredState &&
        (savedExpiredState === 'hide_block' || savedExpiredState === 'replace_text') &&
        savedExpiredState === behavior
      ) {
        applyExpiredBehavior(savedExpiredState);
        return;
      }
    }

    let end = 0;
    if (storage) {
      const savedEnd = parseInt(storage.getItem(endKey) || '0', 10);
      if (savedEnd) end = savedEnd;
    }

    const now = Date.now();
    if (!end || end < now) {
      end = now + duration * 1000;
      if (storage) {
        storage.setItem(endKey, String(end));
        storage.removeItem(frozenKey);
        storage.removeItem(expiredKey);
      }
    }

    let frameId = 0;
    let timeoutId = 0;

    const cleanup = () => {
      if (frameId) cancelAnimationFrame(frameId);
      if (timeoutId) clearTimeout(timeoutId);
      frameId = 0;
      timeoutId = 0;
    };

    const updateDigits = (remainingMs) => {
      const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
      const minuteText = formatUnit((totalSeconds / 60) | 0);
      const secondText = formatUnit(totalSeconds % 60);
      const currentDigits = getDigitNodes(root);

      if (currentDigits.minutes && currentDigits.minutes.textContent !== minuteText) {
        currentDigits.minutes.textContent = minuteText;
      }

      if (currentDigits.seconds && currentDigits.seconds.textContent !== secondText) {
        currentDigits.seconds.textContent = secondText;
      }
    };

    const scheduleTick = () => {
      const delay = (end - Date.now()) % 1000 || 1000;
      timeoutId = setTimeout(() => {
        frameId = requestAnimationFrame(tick);
      }, Math.min(200, delay));
    };

    const tick = () => {
      const remainingMs = end - Date.now();

      if (remainingMs <= 0) {
        switch (behavior) {
          case 'hide_block':
            applyExpiredBehavior('hide_block');
            try {
              if (storage) storage.setItem(expiredKey, 'hide_block');
            } catch {}
            break;
          case 'replace_text':
            applyExpiredBehavior('replace_text');
            try {
              if (storage) storage.setItem(expiredKey, 'replace_text');
            } catch {}
            break;
          case 'freeze_zero':
            applyExpiredBehavior('freeze_zero');
            try {
              if (storage) storage.setItem(frozenKey, '1');
            } catch {}
            break;
          default:
            end = Date.now() + duration * 1000;
            if (storage) storage.setItem(endKey, String(end));
            updateDigits(end - Date.now());
            scheduleTick();
            return;
        }

        cleanup();
        return;
      }

      updateDigits(remainingMs);
      scheduleTick();
    };

    root.addEventListener('cdt:destroy', cleanup, { once: true });
    updateDigits(end - Date.now());
    scheduleTick();
  };

  const initAll = () => {
    document.querySelectorAll('.cdt-root').forEach(initCountdown);
  };

  const resetAndInit = (root) => {
    resetCountdown(root);
    initCountdown(root);
  };

  const clearStorageForRoots = (scope = document) => {
    const storage = getStorage();
    if (!storage) return;

    const elements =
      scope instanceof Element
        ? scope.matches('.cdt-root')
          ? [scope]
          : Array.from(scope.querySelectorAll('.cdt-root'))
        : Array.from(document.querySelectorAll('.cdt-root'));

    elements.forEach((element) => {
      const storageKey = element.dataset.lsKey || 'cdt-default';
      storage.removeItem(`${storageKey}:end`);
      storage.removeItem(`${storageKey}:frozen`);
      storage.removeItem(`${storageKey}:expired`);
    });
  };

  const refreshAll = () => {
    document.querySelectorAll('.cdt-root').forEach(resetAndInit);
  };

  const scheduleRefreshAll = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        refreshAll();
      });
    });
  };

  window.CartCountdown = {
    clearStorageForRoots,
    initAll,
    refreshAll,
    refreshRoot: resetAndInit,
    scheduleRefreshAll,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  const handleRefreshEvent = (event) => {
    if (
      !event ||
      (event.type !== 'cart:item:added' &&
        event.type !== 'cart:update' &&
        event.type !== 'cart:updated')
    ) {
      return;
    }

    clearStorageForRoots();

    scheduleRefreshAll();
  };

  [
    'shopify:section:load',
    'shopify:section:select',
    'cart:updated',
    'cart:update',
    'cart:item:added',
    'cart-drawer:open',
  ].forEach((eventName) => {
    document.addEventListener(eventName, handleRefreshEvent, true);
  });

  const observeCountdownRoot = (observedRoot) => {
    if (!observedRoot) return;

    new MutationObserver((mutations) => {
      const removedRoots = [];

      for (const mutation of mutations) {
        if (
          mutation.type === 'attributes' &&
          mutation.target instanceof Element &&
          mutation.target.matches('.cdt-root')
        ) {
          if (
            mutation.attributeName === 'data-duration' ||
            mutation.attributeName === 'data-behavior' ||
            mutation.attributeName === 'data-cart-empty'
          ) {
            resetAndInit(mutation.target);
          } else if (mutation.attributeName === 'data-show-line2') {
            syncLine2Visibility(mutation.target);
          }
          continue;
        }

        for (const node of mutation.addedNodes || []) {
          if (node.nodeType !== 1) continue;

          if (node.matches?.('.cdt-root')) {
            resetAndInit(node);
            continue;
          }

          const nestedRoots = node.querySelectorAll?.('.cdt-root');
          if (nestedRoots?.length) {
            nestedRoots.forEach(resetAndInit);
            continue;
          }
        }

        for (const node of mutation.removedNodes || []) {
          if (node.nodeType !== 1) continue;

          if (node.matches?.('.cdt-root')) {
            removedRoots.push(node);
            continue;
          }

          const nestedRoots = node.querySelectorAll?.('.cdt-root');
          if (nestedRoots?.length) {
            removedRoots.push(...nestedRoots);
          }
        }

        if (
          mutation.type === 'childList' &&
          mutation.target instanceof Element &&
          mutation.target.closest('.cdt-line2')
        ) {
          const root = mutation.target.closest('.cdt-root');
          if (root) {
            syncLine2Visibility(root);
          }
        }
      }

      if (
        observedRoot.id === 'main-cart-items' &&
        removedRoots.length &&
        observedRoot.querySelector('.hf-cart-page__empty') &&
        !observedRoot.querySelector('.cdt-root')
      ) {
        removedRoots.forEach((root) => {
          clearStorageForRoots(root);
        });
      }
    }).observe(observedRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-show-line2', 'data-duration', 'data-behavior', 'data-cart-empty'],
    });
  };

  [
    document.getElementById('CartDrawer'),
    document.getElementById('main-cart-items'),
  ].forEach(observeCountdownRoot);
})();

